import React, { useState } from 'react';
import './styles/style.css';

let usrName = prompt("What is your name?");
const defName = "#1 Fan of Callum";

function sayGreeting() {
  if ( usrName ) {
    document.getElementById("usrNameView").innerHTML = `
      <h1>${usrName}'s File Tree Viewer</h1>
    `
  } else if ( !usrName ) {
    document.getElementById("usrNameView").innerHTML = `
      <h1>${defName}'s File Tree Viewer</h1>
    `
    alert("I knew you would try this, nice try! Enjoy your new name :)");
  }
  
}
sayGreeting();
console.log("I knew you would check here too. Hey!")

const Folder = (props) => {

  const [ isOpen, setIsOpen ] = useState(true);
  const { name, children } = props;
  const direction = isOpen ? 'down' : 'right';

  const handleClick = () => setIsOpen(!isOpen);

  return <div className="container">
    <span onClick={handleClick}>
      <i className="blue folder icon"></i>
      <i className={`caret ${direction} icon`}></i>
      </span>
    {name}
      <div style={{ marginLeft: '18px' }}>
        {isOpen ?  children : null }
      </div>
    </div>
};

const File = (props) => {
  const { name } = props;
  const fileExtension = name.split('.')[1];
  const fileIcons = {
    mp4: 'headphones',
    jpeg: 'file image',
    png: 'file image outline',
    app: 'terminal'
  };

  return <div>
    <i className={`${fileIcons[fileExtension]} icon`}></i>
    {name}
    </div>
};

function App() {
  return (
    <div>
      <Folder name="Desktop">
        <Folder name="Music">
          <File name="myfavtrack.mp4" />
          <File name ="linkin_park_numb.mp4" />
          <File name ="metallica_enter_sandman.mp4" />
        </Folder>
        <Folder name="Photos">
          <File name="wedding_day1.jpeg" />
          <File name="mycake.png" />
        </Folder>
      </Folder>

      <Folder name="Applications">
        <File name="VSCode.app"></File>
        <File name="Photoshop.app"></File>
        <File name="Terminal.app"></File>
        <File name="TweetDeck.app"></File>
          <Folder name="Secret Programs">
            <File name="WiFi Hacker.app">Hi</File>
          </Folder>
      </Folder>
    </div>
  )
}


export default App;
